// component
import CustomButton from "../kits/button/CustomButton";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import ColorSchema from "../kits/Color";
import TimeLine from "../kits/timeline/TimeLine";
import { TimeStampToJalali } from "../../utils/helperFunction";
// style
import "./ClewList.scss";
// react
import { Modal } from "react-bootstrap";
import { useState } from "react";
import { result } from "lodash";

export default function StepModal({ show, setShow, info, setInfo }) {
  console.log("info", info);

  const returnStatus = (status) => {
    switch (status) {
      case "3":
        return "انجام شده ";
        break;

      default:
        return "نامشخص";
    }
  };
  // const [timeLineItem, setTimeLineItem] = useState([
  //   {
  //     Icon: (
  //       <div
  //         style={{
  //           color: ColorSchema.white_custom,
  //           marginRight: "auto",
  //           marginLeft: "auto",
  //         }}
  //       >
  //         {info.val}
  //       </div>
  //     ),
  //     bgColor: ColorSchema.primary_custom,
  //     children: (
  //       <div className=" box">
  //         عنوان:{info.title}- توضیحات:{info.description} -اپراتور:
  //         {info.operator} -نتیجه استپ:{info.resultstep} - عنوان وتوضیحات:
  //         {info.titleAndDesc}- توضیحات اپراتور:{info.descOperator} - وضعیت:
  //         {info.selectOperator} - زمان ثبت نتیجه:{info.timeOfResult}

  //       </div>
  //     ),
  //   },
  //   {
  //     Icon: (
  //       <div
  //         style={{
  //           color: ColorSchema.white_custom,
  //           marginRight: "auto",
  //           marginLeft: "auto",
  //         }}
  //       >
  //         {info.val}
  //       </div>
  //     ),
  //     bgColor: ColorSchema.pink_custom,
  //     children: (
  //       <div className="box ">
  //         عنوان:{info.title}- توضیحات:{info.description} -اپراتور:
  //         {info.operator} -نتیجه استپ:{info.resultstep} - عنوان وتوضیحات:
  //         {info.titleAndDesc}- توضیحات اپراتور:{info.descOperator} - وضعیت:
  //         {info.selectOperator} - زمان ثبت نتیجه:{info.timeOfResult}
  //       </div>
  //     ),
  //   },
  // ]);
  return (
    <>
      <Modal
        size="xl"
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            استپ ها
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-modalstep">
            {info?.map((v, i) => {
              return (
                <TimeLine
                  bgColor={"pink"}
                  children={
                    <div className="box ">
                      <p
                        style={{
                          fontSize: "13px",
                          marginTop: "15px",
                          marginRight: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        عنوان:
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.title ? v.title : "---"}
                        </span>
                        <span className="comma">،</span>
                        توضیحات:
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.description ? v.description : "---"}
                        </span>
                        <span className="comma">،</span>
                        اپراتور:
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.title ? v.title : "---"}
                        </span>
                        <span className="comma">،</span>
                        نتیجه استپ:
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.last_step_id == v.status_true
                            ? "موفق"
                            : v.last_step_id == v.status_false
                            ? "ناموفق"
                            : "نامشخص"}
                        </span>
                        <span className="comma">،</span>
                        توضیحات اپراتور:{" "}
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.operator_text ? v.operator_text : "---"}
                        </span>
                        <span className="comma">،</span>
                        وضعیت:
                        <span
                          style={{
                            marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.status ? returnStatus(v.status) : "---"}
                        </span>
                        <span className="comma">،</span>
                        زمان ثبت نتیجه:
                        <span
                          style={{
                            // marginRight: "5px",
                            // marginLeft: "5px",
                            color: ColorSchema.blue_custom,
                          }}
                        >
                          {v.do_tm
                            ? TimeStampToJalali(parseInt(v.do_tm) * 1000)
                            : "---"}
                        </span>
                      </p>
                    </div>
                  }
                ></TimeLine>
              );
            })}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
// 3 anjam shode
